import { render, staticRenderFns } from "./WizardSectionHeader.vue?vue&type=template&id=26aa68fd&scoped=true&"
import script from "./WizardSectionHeader.vue?vue&type=script&lang=js&"
export * from "./WizardSectionHeader.vue?vue&type=script&lang=js&"
import style0 from "./WizardSectionHeader.vue?vue&type=style&index=0&id=26aa68fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26aa68fd",
  null
  
)

export default component.exports